export const enUS = {
  hkid:'HKID',
  passport: 'Passport',
  pleaseEnterAllChars: 'Please enter all characters of your HKID. For example, if your HKID is A123456(7), please enter A1234567.',
  cancel: 'cancel',
}
